export const fontOptions = [
  // Sans
  { value: 'Inter, sans-serif', label: 'Inter' },
  { value: 'Roboto, sans-serif', label: 'Roboto' },
  { value: '"Open Sans", sans-serif', label: 'Open Sans' },
  { value: 'Lato, sans-serif', label: 'Lato' },
  { value: 'Montserrat, sans-serif', label: 'Montserrat' },
  { value: 'Poppins, sans-serif', label: 'Poppins' },
  { value: 'Nunito, sans-serif', label: 'Nunito' },
  { value: 'Raleway, sans-serif', label: 'Raleway' },
  { value: '"Work Sans", sans-serif', label: 'Work Sans' },
  { value: '"Source Sans 3", sans-serif', label: 'Source Sans 3' },
  { value: 'Manrope, sans-serif', label: 'Manrope' },
  { value: 'Mulish, sans-serif', label: 'Mulish' },
  { value: '"DM Sans", sans-serif', label: 'DM Sans' },
  { value: '"PT Sans", sans-serif', label: 'PT Sans' },
  { value: '"Noto Sans", sans-serif', label: 'Noto Sans' },
  { value: 'Quicksand, sans-serif', label: 'Quicksand' },
  { value: '"Varela Round", sans-serif', label: 'Varela Round' },
  { value: 'Cabin, sans-serif', label: 'Cabin' },
  { value: 'Assistant, sans-serif', label: 'Assistant' },
  { value: 'Hind, sans-serif', label: 'Hind' },
  { value: 'Karla, sans-serif', label: 'Karla' },
  { value: 'Arimo, sans-serif', label: 'Arimo' },
  { value: 'Overpass, sans-serif', label: 'Overpass' },
  { value: 'Rubik, sans-serif', label: 'Rubik' },
  { value: 'Barlow, sans-serif', label: 'Barlow' },
  { value: '"Exo 2", sans-serif', label: 'Exo 2' },
  { value: 'Asap, sans-serif', label: 'Asap' },
  { value: 'Ubuntu, sans-serif', label: 'Ubuntu' },
  { value: '"Fira Sans", sans-serif', label: 'Fira Sans' },
  { value: '"IBM Plex Sans", sans-serif', label: 'IBM Plex Sans' },
  { value: 'Figtree, sans-serif', label: 'Figtree' },
  { value: 'Lexend, sans-serif', label: 'Lexend' },
  { value: '"Plus Jakarta Sans", sans-serif', label: 'Plus Jakarta Sans' },
  { value: 'Outfit, sans-serif', label: 'Outfit' },
  { value: 'Sora, sans-serif', label: 'Sora' },
  { value: '"Space Grotesk", sans-serif', label: 'Space Grotesk' },
  { value: '"Red Hat Display", sans-serif', label: 'Red Hat Display' },
  { value: '"Public Sans", sans-serif', label: 'Public Sans' },
  { value: 'Urbanist, sans-serif', label: 'Urbanist' },
  { value: '"M PLUS 1p", sans-serif', label: 'M PLUS 1p' },
  { value: '"M PLUS Rounded 1c", sans-serif', label: 'M PLUS Rounded 1c' },
  { value: '"Noto Sans Display", sans-serif', label: 'Noto Sans Display' },
  { value: '"Noto Sans JP", sans-serif', label: 'Noto Sans JP' },
  { value: '"Noto Sans KR", sans-serif', label: 'Noto Sans KR' },
  { value: 'Archivo, sans-serif', label: 'Archivo' },
  { value: '"Archivo Narrow", sans-serif', label: 'Archivo Narrow' },
  { value: '"Barlow Condensed", sans-serif', label: 'Barlow Condensed' },
  { value: 'Chivo, sans-serif', label: 'Chivo' },
  { value: 'Questrial, sans-serif', label: 'Questrial' },
  { value: 'Kanit, sans-serif', label: 'Kanit' },
  { value: 'Prompt, sans-serif', label: 'Prompt' },
  { value: '"Maven Pro", sans-serif', label: 'Maven Pro' },
  { value: 'Khand, sans-serif', label: 'Khand' },
  { value: '"Lexend Deca", sans-serif', label: 'Lexend Deca' },
  { value: '"League Spartan", sans-serif', label: 'League Spartan' },
  { value: 'Yantramanav, sans-serif', label: 'Yantramanav' },
  { value: '"Hammersmith One", sans-serif', label: 'Hammersmith One' },
  { value: '"Fira Sans Condensed", sans-serif', label: 'Fira Sans Condensed' },
  { value: 'Saira, sans-serif', label: 'Saira' },
  { value: '"Saira Condensed", sans-serif', label: 'Saira Condensed' },

  // Serif
  { value: '"Playfair Display", serif', label: 'Playfair Display' },
  { value: 'Lora, serif', label: 'Lora' },
  { value: 'Merriweather, serif', label: 'Merriweather' },
  { value: '"Libre Baskerville", serif', label: 'Libre Baskerville' },
  { value: '"Crimson Text", serif', label: 'Crimson Text' },
  { value: '"DM Serif Display", serif', label: 'DM Serif Display' },
  { value: '"Cormorant Garamond", serif', label: 'Cormorant Garamond' },
  { value: '"EB Garamond", serif', label: 'EB Garamond' },
  { value: '"PT Serif", serif', label: 'PT Serif' },
  { value: '"Noto Serif", serif', label: 'Noto Serif' },
  { value: 'Spectral, serif', label: 'Spectral' },
  { value: '"Source Serif 4", serif', label: 'Source Serif 4' },
  { value: 'Alegreya, serif', label: 'Alegreya' },
  { value: 'Cardo, serif', label: 'Cardo' },
  { value: '"Gentium Book Plus", serif', label: 'Gentium Book Plus' },
  { value: 'Cinzel, serif', label: 'Cinzel' },
  { value: '"Bodoni Moda", serif', label: 'Bodoni Moda' },
  { value: 'Prata, serif', label: 'Prata' },
  { value: '"Abril Fatface", serif', label: 'Abril Fatface' },
  { value: '"Gilda Display", serif', label: 'Gilda Display' },
  { value: 'Arvo, serif', label: 'Arvo' },
  { value: '"Bree Serif", serif', label: 'Bree Serif' },
  { value: 'BioRhyme, serif', label: 'BioRhyme' },
  { value: 'Cormorant, serif', label: 'Cormorant' },
  { value: '"Cormorant Infant", serif', label: 'Cormorant Infant' },
  { value: '"Cormorant SC", serif', label: 'Cormorant SC' },
  { value: '"Cormorant Unicase", serif', label: 'Cormorant Unicase' },
  { value: 'Domine, serif', label: 'Domine' },
  { value: 'Neuton, serif', label: 'Neuton' },
  { value: '"Old Standard TT", serif', label: 'Old Standard TT' },
  { value: '"Playfair Display SC", serif', label: 'Playfair Display SC' },
  { value: 'Pridi, serif', label: 'Pridi' },
  { value: '"Rozha One", serif', label: 'Rozha One' },
  { value: 'Sanchez, serif', label: 'Sanchez' },
  { value: '"Slabo 13px", serif', label: 'Slabo 13px' },
  { value: '"Slabo 27px", serif', label: 'Slabo 27px' },
  { value: 'Tinos, serif', label: 'Tinos' },
  { value: 'Vollkorn, serif', label: 'Vollkorn' },
  { value: 'Yrsa, serif', label: 'Yrsa' },
  { value: '"Zilla Slab", serif', label: 'Zilla Slab' },

  // Display
  { value: '"Bebas Neue", sans-serif', label: 'Bebas Neue' },
  { value: 'Oswald, sans-serif', label: 'Oswald' },
  { value: 'Anton, sans-serif', label: 'Anton' },
  { value: 'Pacifico, cursive', label: 'Pacifico' },
  { value: '"Josefin Sans", sans-serif', label: 'Josefin Sans' },
  { value: 'Lobster, cursive', label: 'Lobster' },
  { value: '"Archivo Black", sans-serif', label: 'Archivo Black' },
  { value: 'Righteous, cursive', label: 'Righteous' },
  { value: 'Ultra, serif', label: 'Ultra' },
  { value: '"Alfa Slab One", cursive', label: 'Alfa Slab One' },
  { value: 'Fredoka, sans-serif', label: 'Fredoka' },
  { value: 'Orbitron, sans-serif', label: 'Orbitron' },
  { value: 'Teko, sans-serif', label: 'Teko' },
  { value: 'Changa, sans-serif', label: 'Changa' },
  { value: 'Bangers, cursive', label: 'Bangers' },
  { value: 'Chewy, cursive', label: 'Chewy' },
  { value: '"Cinzel Decorative", serif', label: 'Cinzel Decorative' },
  { value: '"Fugaz One", cursive', label: 'Fugaz One' },
  { value: '"Luckiest Guy", cursive', label: 'Luckiest Guy' },
  { value: 'Monoton, cursive', label: 'Monoton' },
  { value: '"Press Start 2P", cursive', label: 'Press Start 2P' },
  { value: 'Rye, cursive', label: 'Rye' },
  { value: 'Shrikhand, cursive', label: 'Shrikhand' },
  { value: '"Unica One", sans-serif', label: 'Unica One' },
  { value: '"Yeseva One", serif', label: 'Yeseva One' },
  { value: '"Poiret One", cursive', label: 'Poiret One' },
  { value: 'Playball, cursive', label: 'Playball' },
  { value: '"Fredericka the Great", cursive', label: 'Fredericka the Great' },
  { value: 'Limelight, cursive', label: 'Limelight' },
  { value: '"Marcellus SC", serif', label: 'Marcellus SC' },
  { value: '"Lobster Two", cursive', label: 'Lobster Two' },
  { value: 'Sigmar, cursive', label: 'Sigmar' },
  { value: '"Bowlby One SC", cursive', label: 'Bowlby One SC' },
  { value: '"Black Ops One", cursive', label: 'Black Ops One' },

  // Script / Handwriting
  { value: '"Great Vibes", cursive', label: 'Great Vibes' },
  { value: 'Sacramento, cursive', label: 'Sacramento' },
  { value: 'Allura, cursive', label: 'Allura' },
  { value: '"Alex Brush", cursive', label: 'Alex Brush' },
  { value: 'Courgette, cursive', label: 'Courgette' },
  { value: 'Cookie, cursive', label: 'Cookie' },
  { value: 'Parisienne, cursive', label: 'Parisienne' },
  { value: 'Satisfy, cursive', label: 'Satisfy' },
  { value: 'Caveat, cursive', label: 'Caveat' },
  { value: 'Kalam, cursive', label: 'Kalam' },
  { value: '"Patrick Hand", cursive', label: 'Patrick Hand' },
  { value: '"Dancing Script", cursive', label: 'Dancing Script' },
  { value: '"Indie Flower", cursive', label: 'Indie Flower' },
  { value: '"Shadows Into Light", cursive', label: 'Shadows Into Light' },
  { value: '"Permanent Marker", cursive', label: 'Permanent Marker' },
  { value: 'Yellowtail, cursive', label: 'Yellowtail' },
  { value: '"Marck Script", cursive', label: 'Marck Script' },
  { value: 'Handlee, cursive', label: 'Handlee' },
  { value: '"Architects Daughter", cursive', label: 'Architects Daughter' },
  { value: '"Reenie Beanie", cursive', label: 'Reenie Beanie' },
  { value: '"Bad Script", cursive', label: 'Bad Script' },
  { value: '"Homemade Apple", cursive', label: 'Homemade Apple' },
  { value: '"Just Another Hand", cursive', label: 'Just Another Hand' },
  { value: '"Rock Salt", cursive', label: 'Rock Salt' },
  { value: '"Nothing You Could Do", cursive', label: 'Nothing You Could Do' },
  { value: '"Kaushan Script", cursive', label: 'Kaushan Script' },
  { value: '"Gloria Hallelujah", cursive', label: 'Gloria Hallelujah' },
  { value: 'Schoolbell, cursive', label: 'Schoolbell' },
  { value: '"Amatic SC", cursive', label: 'Amatic SC' },
  { value: '"Cedarville Cursive", cursive', label: 'Cedarville Cursive' },
  { value: '"Gochi Hand", cursive', label: 'Gochi Hand' },
  { value: '"Just Me Again Down Here", cursive', label: 'Just Me Again Down Here' },
  { value: '"La Belle Aurore", cursive', label: 'La Belle Aurore' },
  { value: '"Leckerli One", cursive', label: 'Leckerli One' },
  { value: 'Merienda, cursive', label: 'Merienda' },
  { value: '"Merienda One", cursive', label: 'Merienda One' },
  { value: '"Nanum Pen Script", cursive', label: 'Nanum Pen Script' },
  { value: '"Pinyon Script", cursive', label: 'Pinyon Script' },
  { value: 'Tangerine, cursive', label: 'Tangerine' },
  { value: 'Yesteryear, cursive', label: 'Yesteryear' },
  { value: 'Zeyada, cursive', label: 'Zeyada' },
  { value: 'Sriracha, cursive', label: 'Sriracha' },
  { value: 'Damion, cursive', label: 'Damion' },
  { value: 'Stalemate, cursive', label: 'Stalemate' },
  { value: 'Calligraffitti, cursive', label: 'Calligraffitti' },
  { value: 'Italianno, cursive', label: 'Italianno' },
  { value: 'Kristi, cursive', label: 'Kristi' },
  { value: '"Mr De Haviland", cursive', label: 'Mr De Haviland' },

  // Mono
  { value: '"JetBrains Mono", monospace', label: 'JetBrains Mono' },
  { value: '"Source Code Pro", monospace', label: 'Source Code Pro' },
  { value: '"IBM Plex Mono", monospace', label: 'IBM Plex Mono' },
  { value: '"Space Mono", monospace', label: 'Space Mono' },
  { value: 'Inconsolata, monospace', label: 'Inconsolata' },
  { value: '"Fira Code", monospace', label: 'Fira Code' },
  { value: '"Roboto Mono", monospace', label: 'Roboto Mono' },
  { value: '"PT Mono", monospace', label: 'PT Mono' },
  { value: '"Ubuntu Mono", monospace', label: 'Ubuntu Mono' },
  { value: '"Anonymous Pro", monospace', label: 'Anonymous Pro' },
  { value: 'Cousine, monospace', label: 'Cousine' },
  { value: '"Overpass Mono", monospace', label: 'Overpass Mono' },
  { value: '"Noto Sans Mono", monospace', label: 'Noto Sans Mono' },
  { value: '"Share Tech Mono", monospace', label: 'Share Tech Mono' },
  { value: '"DM Mono", monospace', label: 'DM Mono' },
  { value: '"Cutive Mono", monospace', label: 'Cutive Mono' },
  { value: '"Victor Mono", monospace', label: 'Victor Mono' },
  { value: '"Spline Sans Mono", monospace', label: 'Spline Sans Mono' },
  { value: '"Fira Mono", monospace', label: 'Fira Mono' },
  { value: '"Red Hat Mono", monospace', label: 'Red Hat Mono' },

  // Extended
  { value: 'Abel, sans-serif', label: 'Abel' },
  { value: 'Acme, sans-serif', label: 'Acme' },
  { value: 'Actor, sans-serif', label: 'Actor' },
  { value: 'Adamina, serif', label: 'Adamina' },
  { value: '"Advent Pro", sans-serif', label: 'Advent Pro' },
  { value: '"Alegreya Sans", sans-serif', label: 'Alegreya Sans' },
  { value: '"Alegreya Sans SC", sans-serif', label: 'Alegreya Sans SC' },
  { value: 'Alata, sans-serif', label: 'Alata' },
  { value: 'Alatsi, sans-serif', label: 'Alatsi' },
  { value: 'Amaranth, sans-serif', label: 'Amaranth' },
  { value: 'Amiko, sans-serif', label: 'Amiko' },
  { value: 'Anaheim, sans-serif', label: 'Anaheim' },
  { value: 'Antic, sans-serif', label: 'Antic' },
  { value: '"Antic Slab", serif', label: 'Antic Slab' },
  { value: 'Average, serif', label: 'Average' },
  { value: '"Average Sans", sans-serif', label: 'Average Sans' },
  { value: '"Barlow Semi Condensed", sans-serif', label: 'Barlow Semi Condensed' },
  { value: 'Bellota, sans-serif', label: 'Bellota' },
  { value: '"Bellota Text", sans-serif', label: 'Bellota Text' },
  { value: '"Be Vietnam Pro", sans-serif', label: 'Be Vietnam Pro' },
  { value: 'Biryani, sans-serif', label: 'Biryani' },
  { value: 'B612, sans-serif', label: 'B612' },
  { value: '"B612 Mono", monospace', label: 'B612 Mono' },
  { value: '"Cabin Condensed", sans-serif', label: 'Cabin Condensed' },
  { value: 'Cairo, sans-serif', label: 'Cairo' },
  { value: 'Candal, sans-serif', label: 'Candal' },
  { value: 'Cantarell, sans-serif', label: 'Cantarell' },
  { value: 'Carme, sans-serif', label: 'Carme' },
  { value: 'Catamaran, sans-serif', label: 'Catamaran' },
  { value: '"Chakra Petch", sans-serif', label: 'Chakra Petch' },
  { value: '"Changa One", sans-serif', label: 'Changa One' },
  { value: 'Coda, sans-serif', label: 'Coda' },
  { value: 'Comfortaa, sans-serif', label: 'Comfortaa' },
  { value: 'Commissioner, sans-serif', label: 'Commissioner' },
  { value: 'Convergence, sans-serif', label: 'Convergence' },
  { value: '"Didact Gothic", sans-serif', label: 'Didact Gothic' },
  { value: 'Dosis, sans-serif', label: 'Dosis' },
  { value: 'Economica, sans-serif', label: 'Economica' },
  { value: '"El Messiri", sans-serif', label: 'El Messiri' },
  { value: '"Encode Sans", sans-serif', label: 'Encode Sans' },
  { value: '"Encode Sans Condensed", sans-serif', label: 'Encode Sans Condensed' },
  { value: 'Epilogue, sans-serif', label: 'Epilogue' },
  { value: '"Expletus Sans", sans-serif', label: 'Expletus Sans' },
  { value: 'Farro, sans-serif', label: 'Farro' },
  { value: 'Faustina, serif', label: 'Faustina' },
  { value: 'Federo, sans-serif', label: 'Federo' },
  { value: 'Fenix, serif', label: 'Fenix' },
  { value: '"Fjalla One", sans-serif', label: 'Fjalla One' },
  { value: '"Francois One", sans-serif', label: 'Francois One' },
  { value: '"Frank Ruhl Libre", serif', label: 'Frank Ruhl Libre' },
  { value: 'Gudea, sans-serif', label: 'Gudea' },
  { value: 'Heebo, sans-serif', label: 'Heebo' },
  { value: '"IBM Plex Sans Condensed", sans-serif', label: 'IBM Plex Sans Condensed' },
  { value: '"IBM Plex Sans Thai", sans-serif', label: 'IBM Plex Sans Thai' },
  { value: 'Imprima, sans-serif', label: 'Imprima' },
  { value: '"Inria Sans", sans-serif', label: 'Inria Sans' },
  { value: '"Istok Web", sans-serif', label: 'Istok Web' },
  { value: 'Jost, sans-serif', label: 'Jost' },
  { value: 'Jura, sans-serif', label: 'Jura' },
  { value: 'K2D, sans-serif', label: 'K2D' },
  { value: '"Kumbh Sans", sans-serif', label: 'Kumbh Sans' },
  { value: 'Laila, serif', label: 'Laila' },
  { value: 'Lalezar, sans-serif', label: 'Lalezar' },
  { value: 'Ledger, serif', label: 'Ledger' },
  { value: '"Libre Franklin", sans-serif', label: 'Libre Franklin' },
  { value: 'Livvic, sans-serif', label: 'Livvic' },
  { value: 'Mada, sans-serif', label: 'Mada' },
  { value: 'Mako, sans-serif', label: 'Mako' },
  { value: 'Martel, serif', label: 'Martel' },
  { value: '"Martel Sans", sans-serif', label: 'Martel Sans' },
  { value: 'Monda, sans-serif', label: 'Monda' },
  { value: '"Montserrat Alternates", sans-serif', label: 'Montserrat Alternates' },
  { value: '"Montserrat Subrayada", sans-serif', label: 'Montserrat Subrayada' },
  { value: 'Nobile, sans-serif', label: 'Nobile' },
  { value: '"Noticia Text", serif', label: 'Noticia Text' },
  { value: '"Nunito Sans", sans-serif', label: 'Nunito Sans' },
  { value: 'Oxygen, sans-serif', label: 'Oxygen' },
  { value: 'Padauk, sans-serif', label: 'Padauk' },
  { value: '"Pathway Gothic One", sans-serif', label: 'Pathway Gothic One' },
  { value: '"Paytone One", sans-serif', label: 'Paytone One' },
  { value: 'Philosopher, serif', label: 'Philosopher' },
  { value: '"Pontano Sans", sans-serif', label: 'Pontano Sans' },
  { value: 'Quattrocento, serif', label: 'Quattrocento' },
  { value: '"Quattrocento Sans", sans-serif', label: 'Quattrocento Sans' },
  { value: '"Ropa Sans", sans-serif', label: 'Ropa Sans' },
  { value: 'Rosario, sans-serif', label: 'Rosario' },
  { value: '"Rubik Mono One", sans-serif', label: 'Rubik Mono One' },
  { value: '"Rubik Wet Paint", cursive', label: 'Rubik Wet Paint' },
  { value: 'Sarabun, sans-serif', label: 'Sarabun' },
  { value: 'Sarala, sans-serif', label: 'Sarala' },
  { value: 'Sarpanch, sans-serif', label: 'Sarpanch' },
  { value: '"Secular One", sans-serif', label: 'Secular One' },
  { value: 'Signika, sans-serif', label: 'Signika' },
  { value: '"Signika Negative", sans-serif', label: 'Signika Negative' },
  { value: 'Sintony, sans-serif', label: 'Sintony' },
  { value: '"Sofia Sans", sans-serif', label: 'Sofia Sans' },
  { value: 'Spinnaker, sans-serif', label: 'Spinnaker' },
  { value: 'Staatliches, sans-serif', label: 'Staatliches' },
  { value: 'Tauri, sans-serif', label: 'Tauri' },
  { value: '"Tenor Sans", sans-serif', label: 'Tenor Sans' },
];
